import $ from 'jquery';

$('.our-directions__all').on('click', function () {
    $('.menu-panel').toggleClass('open');
    $('.menu-panel nav').removeClass('top-hide').addClass('top');
    // $('.menu-panel').toggleClass('hide');


    $('.line').addClass("hide-cross");
    $('.cross').removeClass("hide-cross");

    if ($('.menu-panel').hasClass('open')) {
        $('.calculate').addClass('max-z');
        $('.calc-button').addClass('hide-s')
        $('.shadow').removeClass('hide-s');

        if ($('.shadow').on('click', function () {
            $('.shadow').addClass('hide-s');
            $('.menu-panel').removeClass('open');
            $('.line').removeClass("hide-cross");
            $('.cross').addClass("hide-cross");
            $('.menu-panel nav').addClass('top-hide').removeClass('top');


            setTimeout(function () {
                $('.calculate').removeClass('max-z');
            }, 500);
            setTimeout(function () {
                $('.calc-button').removeClass('hide-s');
            }, 100);
        })) ;
    } else {
        $('.shadow').addClass('hide-s');

        setTimeout(function () {
            $('.calculate').removeClass('max-z');
        }, 500);
        setTimeout(function () {
            $('.calc-button').removeClass('hide-s');
        }, 100);
    }
});

$('.calculate-logo').on('click', function () {
    $('.menu-panel').toggleClass('open');
    $('.menu-panel nav').toggleClass('top-hide').toggleClass('top');
    // $('.menu-panel').toggleClass('hide');


    $('.line').toggleClass("hide-cross");
    $('.cross').toggleClass("hide-cross");

    if ($('.menu-panel').hasClass('open')) {
        $('.calculate').addClass('max-z');
        $('.calc-button').addClass('hide-s')
        $('.shadow').removeClass('hide-s');

        if ($('.shadow').on('click', function () {
            $('.shadow').addClass('hide-s');
            $('.menu-panel').removeClass('open');
            $('.line').removeClass("hide-cross");
            $('.cross').addClass("hide-cross");
            setTimeout(function () {
                $('.calculate').removeClass('max-z');
            }, 500);
            setTimeout(function () {
                $('.calc-button').removeClass('hide-s');
            }, 100);
        })) ;
    } else {
        $('.shadow').addClass('hide-s');

        setTimeout(function () {
            $('.calculate').removeClass('max-z');
        }, 500);
        setTimeout(function () {
            $('.calc-button').removeClass('hide-s');
        }, 100);
    }

});
